<ng-container *ngTemplateOutlet="loadingProductImages() ? skeletonLoader : carousel"
	></ng-container>

<ng-template #carousel>
	<pdp-carousel id="carousel"
		[available]="available()"
		[catalogEntryTypeCode]="catalogEntryTypeCode()"
		[eCode]="product()?.partNumber"
		[productName]="product()?.name"
		[swatchColor]="swatchColor()"
		[imageBadge]="product()?.badge"
		[lazyLoadImage]="lazyLoadImage()"
		[customizedUrls]="hasColorQueryParams() && customizedUrls()"
		[shouldShowOutOfStockRecs]="false"
		[shouldHaveBorder]="shouldHaveBorder()"
		[killSwitches]="killSwitches()"
		[mediaSetResponse]="mediaSet()"
	></pdp-carousel>
</ng-template>

<ng-template #skeletonLoader>
	<pdp-carousel-skeleton-loader id="skeleton"></pdp-carousel-skeleton-loader>
</ng-template>
